// 全局的过滤器
import Vue from 'vue'
import moment from 'moment'
import i18n from '~/i18n'
import GLOBAL_VAR from './global'

Vue.filter('dateFormat', (input, pattern = 'YYYY-MM-DD') => {
  return input ? moment(input).format(pattern) : ''
})

Vue.filter('subjectFormat', (value, subjects) => {
  let result = i18n.t('topedit.filter.empty')
  if (value.length === 0) {
    return result
  }
  result = ''
  subjects.forEach(element => {
    if (value[0] === element.id) {
      result += element.enName + ','
      element.children.forEach(child => {
        if (value[1] === child.id) {
          result += child.enName
        }
      })
    }
  })
  return result
})

Vue.filter('wayFormat', (value, options) => {
  let result = i18n.t('topedit.filter.empty')
  if (!value) {
    return result
  }
  options.forEach(element => {
    if (element.id === value) {
      result = element.name
    }
  })
  return result
})

Vue.filter('roleFormat', (value) => {
  // 账号所属角色标识, 0-普通用户, 1-超级管理员 / 2-管理员 / 3-客服 / 4-稿件处理员 / 5-质控编辑 / 6-编辑 / 7-网站编辑
  return {
    [GLOBAL_VAR.ROLE_0]: i18n.t('topedit.filter.role[0]'),
    [GLOBAL_VAR.ROLE_1]: i18n.t('topedit.filter.role[1]'),
    [GLOBAL_VAR.ROLE_2]: i18n.t('topedit.filter.role[2]'),
    [GLOBAL_VAR.ROLE_3]: i18n.t('topedit.filter.role[3]'),
    [GLOBAL_VAR.ROLE_4]: i18n.t('topedit.filter.role[4]'),
    [GLOBAL_VAR.ROLE_5]: i18n.t('topedit.filter.role[5]'),
    [GLOBAL_VAR.ROLE_6]: i18n.t('topedit.filter.role[6]'),
    [GLOBAL_VAR.ROLE_7]: i18n.t('topedit.filter.role[7]'),
    [GLOBAL_VAR.ROLE_8]: i18n.t('topedit.filter.role[8]')
  }[value]
})

Vue.filter('paperStatusFormat', (value, isUser = '0') => {
  // <!-- 稿件状态, 1-已提交 / 2-已报价 / 3-待处理 / 4-已付款 / 5-处理中 / 6-编辑中 / 7-编辑完成 / 8-质控中 / 9-已完成 -->
  if (isUser === '1' && (value === GLOBAL_VAR.PAPER_STATUS_6 || value === GLOBAL_VAR.PAPER_STATUS_7 || value === GLOBAL_VAR.PAPER_STATUS_8)) {
    return i18n.t('topedit.filter.paperStatus[6]')
  }
  return {
    [GLOBAL_VAR.PAPER_STATUS_1]: i18n.t('topedit.filter.paperStatus[1]'),
    [GLOBAL_VAR.PAPER_STATUS_2]: i18n.t('topedit.filter.paperStatus[2]'),
    [GLOBAL_VAR.PAPER_STATUS_3]: i18n.t('topedit.filter.paperStatus[3]'),
    [GLOBAL_VAR.PAPER_STATUS_4]: i18n.t('topedit.filter.paperStatus[4]'),
    [GLOBAL_VAR.PAPER_STATUS_5]: i18n.t('topedit.filter.paperStatus[5]'),
    [GLOBAL_VAR.PAPER_STATUS_6]: i18n.t('topedit.filter.paperStatus[6]'),
    [GLOBAL_VAR.PAPER_STATUS_7]: i18n.t('topedit.filter.paperStatus[7]'),
    [GLOBAL_VAR.PAPER_STATUS_8]: i18n.t('topedit.filter.paperStatus[8]'),
    [GLOBAL_VAR.PAPER_STATUS_9]: i18n.t('topedit.filter.paperStatus[9]')
  }[value]
})

Vue.filter('taskStatusFormat', (value) => {
  // 全局任务状态 已分配(编辑)-1, 已拒绝-2, 编辑中-3, 编辑完成-4, 已分配(质控)-5, 已拒绝(质控)-6, 质控中-7, 质控完成-8, 已完成-9
  return {
    [GLOBAL_VAR.TASK_STATUS_1]: i18n.t('topedit.filter.taskStatus[1]'),
    [GLOBAL_VAR.TASK_STATUS_2]: i18n.t('topedit.filter.taskStatus[2]'),
    [GLOBAL_VAR.TASK_STATUS_3]: i18n.t('topedit.filter.taskStatus[3]'),
    [GLOBAL_VAR.TASK_STATUS_4]: i18n.t('topedit.filter.taskStatus[4]'),
    [GLOBAL_VAR.TASK_STATUS_5]: i18n.t('topedit.filter.taskStatus[5]'),
    [GLOBAL_VAR.TASK_STATUS_6]: i18n.t('topedit.filter.taskStatus[6]'),
    [GLOBAL_VAR.TASK_STATUS_7]: i18n.t('topedit.filter.taskStatus[7]'),
    [GLOBAL_VAR.TASK_STATUS_8]: i18n.t('topedit.filter.taskStatus[8]'),
    [GLOBAL_VAR.TASK_STATUS_9]: i18n.t('topedit.filter.taskStatus[9]')
  }[value]
})

Vue.filter('payTypeFormat', (value) => {
  // 支付方式 0-余额 / 1-微信 / 2-支付宝 / 3-银联 / 4-联系客服支付
  return {
    [GLOBAL_VAR.PAY_TYPE_0]: i18n.t('topedit.filter.payType[0]'),
    [GLOBAL_VAR.PAY_TYPE_1]: i18n.t('topedit.filter.payType[1]'),
    [GLOBAL_VAR.PAY_TYPE_2]: i18n.t('topedit.filter.payType[2]'),
    [GLOBAL_VAR.PAY_TYPE_3]: i18n.t('topedit.filter.payType[3]'),
    [GLOBAL_VAR.PAY_TYPE_4]: i18n.t('topedit.filter.payType[4]')
  }[value]
})

Vue.filter('localeFormat', (value) => {
  return {
    'zh': '中文',
    'en': 'English'
  }[value]
})



// WEBPACK FOOTER //
// ./src/utils/filter.js